import { render } from "./TableNav.vue?vue&type=template&id=fa18e400&scoped=true"
import script from "./TableNav.vue?vue&type=script&lang=js"
export * from "./TableNav.vue?vue&type=script&lang=js"

import "./TableNav.vue?vue&type=style&index=0&id=fa18e400&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa18e400"]])

export default __exports__